// Read the API base URL from environment variables provided by Vue CLI
const API_BASE = process.env.VUE_APP_API_BASE_URL;

// Optional: Add a check or default if the variable isn't set during development
if (!API_BASE && process.env.NODE_ENV === 'development') {
  console.warn("Warning: VUE_APP_API_BASE_URL environment variable is not set! Check your .env files.");
  // You could potentially set a fallback here for safety, but it's better
  // to ensure the .env files are correctly configured.
  // Example fallback (use with caution):
  // API_BASE = 'http://localhost:8080/fallback-api/';
} else if (!API_BASE && process.env.NODE_ENV === 'production') {
   console.error("CRITICAL ERROR: VUE_APP_API_BASE_URL is not set for production build!");
   // In production, it's often better to fail loudly if configuration is missing.
}


export {
  API_BASE
}
